import {Map} from 'immutable'
import PropTypes from 'prop-types'

import Button from '../../../../../shared_components/mui_base_components/button/Button'
import Modals from '../../../../../shared_components/core/modals/Modals'
import RemoveFromPro from './RemoveFromPro'

import './removeClientModal.scss'

const RemoveClientModal = props => (
  <Modals.ButtonPopUpModalLarge
    launcher={
      <Button
        className='remove-client-button'
        color='cancel'
        disabled={props.disabled}
        loading={props.processing}>
        {props.buttonText}
      </Button>
    }>
    <h2>Are you sure you want to remove {props.fullName}?</h2>
    <RemoveFromPro firstName={props.firstName} status={props.clientSeat.get('status')} {...props} />
  </Modals.ButtonPopUpModalLarge>
)

RemoveClientModal.propTypes = {
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
  firstName: PropTypes.string,
  fullName: PropTypes.string,
  clientSeat: PropTypes.instanceOf(Map),
  owner: PropTypes.instanceOf(Map),
  processing: PropTypes.bool
}

export default RemoveClientModal
